import { Col, Flex, Row } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

export function MilestonesHeaderRow() {
  const { t } = useTranslation()

  return (
    <Flex
      className={"border-b border-border rounded-t-card bg-primary/10 p-2 pb-1"}
    >
      <Row className={"flex-nowrap flex-1"} gutter={8}>
        <Col flex={"80px"}></Col>
        <Col className={"min-w-36"} flex={"auto"}>
          <span className={"font-bold"}>
            {t("tabbedForm.milestones.columns.milestone")}
          </span>
        </Col>
        <Col flex={"130px"}>
          <span className={"font-bold"}>
            {t("tabbedForm.milestones.columns.targetStart")}
          </span>
        </Col>
        <Col flex={"130px"}>
          <span className={"font-bold"}>
            {t("tabbedForm.milestones.columns.targetEnd")}
          </span>
        </Col>
        {/*<Col flex={"155px"}>*/}
        {/*  <span className={"font-bold"}>Price</span>*/}
        {/*</Col>*/}
        <Col flex={"155px"}>
          <span className={"font-bold"}>
            {t("tabbedForm.milestones.columns.receivable")}
          </span>
        </Col>
        <Col flex={"155px"}>
          <span className={"font-bold"}>
            {t("tabbedForm.milestones.columns.payable")}
          </span>
        </Col>
        {/*<Col flex={"150px"}>*/}
        {/*  <span className={"font-bold"}>Status</span>*/}
        {/*</Col>*/}
        <Col flex={"42px"} />
      </Row>
    </Flex>
  )
}
